// action
import {
    GET_DOCTOR_SEARCH,
    GET_DOCTOR_SEARCH_FAIL,
    GET_DOCTOR_SEARCH_SUCCESS,
    GET_DOCTOR_SEARCH_RESET
} from '../action/getDoctorSearchAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_DOCTOR_SEARCH:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_DOCTOR_SEARCH_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_DOCTOR_SEARCH_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data,
            }
        case GET_DOCTOR_SEARCH_RESET:
            return initialState
        default:
            return {
                ...state
            }
    }
}